<template>
  <nav class="sidebar-nav">
    <ul class="nav">
        <li class="nav-item">
            <router-link :to="{ name: 'home' }" class="nav-link" id="menuLinkDashboard">
                <i class="fal fa-home-alt fa-fw"></i> Dashboard
            </router-link>
        </li>

        <li class="nav-item nav-dropdown">
            <a class="nav-link nav-dropdown-toggle" href="#" id="menuLinkExpandProviders"><i class="fal fa-user-md fa-fw"></i> Providers</a>
            <ul class="nav-dropdown-items">
                <li class="nav-item">
                    <router-link :to="{ name: 'physicians.map' }" class="nav-link" id="menuLinkPhysicianExplore">
                        <i class="fal fa-map-marked fa-fw"></i> Explore & Analyze
                    </router-link>
                </li>                  
                <li class="nav-item">
                    <router-link :to="{ name: 'physicians.list' }" class="nav-link" id="menuLinkPhysicianList">
                        <i class="fal fa-list fa-fw"></i> Physician List
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'groups.list' }" class="nav-link" id="menuLinkGroupList">
                        <i class="fal fa-users-medical fa-fw"></i> Group List
                    </router-link>
                </li>             
              
                <li class="nav-item">
                    <router-link :to="{ name: 'smart_lists.index' }" class="nav-link" id="menuLinkSmartLists">
                        <i class="fal fa-lightbulb-on fa-fw"></i> Smart Lists

                        <router-link :to="{ name: 'smart_lists.radar' }" class="nav-link d-none" id="menuLinkSmartListRadar">RADAR</router-link>
                        <router-link :to="{ name: 'smart_lists.new' }" class="nav-link d-none" id="menuLinkSmartListNewPhysicians">New Physicians</router-link>
                        <router-link :to="{ name: 'smart_lists.top' }" class="nav-link d-none" id="menuLinkSmartListTopPhysicians">Top Physicians</router-link>
                        <router-link :to="{ name: 'smart_lists.latent' }" class="nav-link d-none" id="menuLinkSmartListLatentPhysicians">Latent Physicians</router-link>
                        <router-link :to="{ name: 'smart_lists.new_referrers' }" class="nav-link d-none" id="menuLinkSmartListNewReferrers">New Referrers</router-link>
                    </router-link>
                </li>

                <li class="nav-item nav-dropdown">
                    <a class="nav-link nav-title nav-dropdown-toggle" href="#" id="menuLinkExpandPhysicianTools">Tools</a>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item">
                            <router-link :to="{ name: 'physicians.tools.duplicates' }" class="nav-link" id="menuLinkDuplicateFinder">
                                <i class="fal fa-user-friends fa-fw"></i> Duplicate finder
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{ name: 'physicians.tools.inactive' }" class="nav-link" id="menuLinkInactivePhysicians">
                                <i class="fal fa-user-slash fa-fw"></i> Manage inactive
                            </router-link>
                        </li>
                       <li v-if="perms.can_create_physician" class="nav-item">
                            <router-link :to="{ name: 'physicians.tools.import' }" class="nav-link" id="menuLinkImportPhysicians">
                                <i class="fal fa-file-import fa-fw"></i> Import from CSV
                            </router-link>
                        </li>
                    </ul>
                </li>
            </ul>
        </li>
        <li class="nav-item nav-dropdown">
            <a class="nav-link nav-dropdown-toggle" href="#" id="menuLinkExpandCheckins"><i class="fal fa-check-circle fa-fw"></i> Check-ins</a>
            <ul class="nav-dropdown-items">
                <li class="nav-item">
                    <router-link :to="{ name: 'checkins.index' }" class="nav-link" id="menuLinkCheckins">
                        <i class="fal fa-list fa-fw"></i> All Check-ins
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'goals.index' }" class="nav-link" id="menuLinkGoals">
                        <i class="fal fa-trophy fa-fw"></i> Manage Goals
                    </router-link>
                </li>                                
            </ul>
        </li>

        <li class="nav-item">
            <router-link :to="{ name: 'routes.index' }" class="nav-link" id="menuLinkRoutes">
                <i class="fal fa-route fa-fw"></i> Routes
            </router-link>
        </li>

        <li class="nav-item">
            <router-link :to="{ name: 'campaigns.index' }" class="nav-link" id="menuLinkCampaigns">
                <i class="fal fa-fire-alt fa-fw"></i> Campaigns
            </router-link>
        </li>

        <li class="nav-item">
            <router-link :to="{ name: 'assets.index' }" class="nav-link" id="menuLinkAssets">
                <i class="fal fa-image fa-fw"></i> Media Assets
            </router-link>
        </li>

        <!-- <li class="nav-item">
            <router-link :to="{ name: 'reports.index' }" class="nav-link" id="menuLinkReports">
                <i class="fal fa-chart-bar fa-fw"></i> Reports
            </router-link>
        </li> -->

  


        <li class="nav-title">Admin</li>
     

        <li v-if="perms.can_create_org" class="nav-item">
            <router-link :to="{ name: 'orgs.index' }" class="nav-link" id="menuLinkOrganizationList">
                <i class="fal fa-sitemap fa-fw"></i> Organizations
            </router-link>
        </li>  

        <li v-if="user.org_id" class="nav-item">
            <router-link :to="{ name: 'orgs.show', params: { id: user.org_id } }" class="nav-link" id="menuLinkOrganizationView">
                <i class="fal fa-sitemap fa-fw"></i> Organization
            </router-link>
        </li>

        <li v-if="perms.can_create_client || perms.can_edit_client" class="nav-item" id="menuLinkClientList">
            <router-link :to="{ name: 'clients.index' }" class="nav-link">
                <i class="fal fa-hospital fa-fw"></i> Clients
            </router-link>
        </li>   

        <li v-if="perms.can_do_everything" class="nav-item nav-dropdown">
            <a class="nav-link nav-dropdown-toggle" href="#" id="menuLinkExpandUsers"><i class="fal fa-user-circle fa-fw"></i> Users</a>
            <ul class="nav-dropdown-items">
                <li class="nav-item">
                    <router-link :to="{ name: 'users.index' }" class="nav-link" id="menuLinkUserList">
                        <i class="fal fa-user fa-fw"></i> User Accounts
                    </router-link>
                </li>  
                <li class="nav-item">
                    <router-link :to="{ name: 'roles.index' }" class="nav-link" id="menuLinkRoles">
                        <i class="fal fa-lock-alt fa-fw"></i> Roles
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'permissions.index' }" class="nav-link" id="menuLinkPermissions">
                        <i class="fal fa-key fa-fw"></i> Permissions
                    </router-link>
                </li>
            </ul>
        </li>

        <li v-else class="nav-item">
            <router-link :to="{ name: 'users.index' }" class="nav-link">
                <i class="fal fa-user-circle fa-fw"></i> Users
            </router-link>
        </li>  
        

        <li v-if="perms.can_do_everything" class="nav-item nav-dropdown">
            <a class="nav-link nav-dropdown-toggle" href="#" id="menuLinkExpandSettings"><i class="fal fa-cog"></i> Settings</a>
            <ul class="nav-dropdown-items">
                <li class="nav-item">
                    <router-link :to="{ name: 'admin.asset_types' }" class="nav-link" id="menuLinkSettingsAssetTypes">
                        <i class="fal fa-file-edit fa-fw"></i> Asset Types
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'admin.specialties' }" class="nav-link" id="menuLinkSettingsSpecialties">
                        <i class="fal fa-stethoscope fa-fw"></i> Specialties
                        <router-link :to="{ name: 'admin.specialties.mappings' }" class="nav-link d-none" id="menuLinkSmartListRadar">Mappings</router-link>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'admin.service_lines' }" class="nav-link" id="menuLinkSettingsServiceLines">
                        <i class="fal fa-puzzle-piece fa-fw"></i> Service Lines
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'admin.front_promos' }" class="nav-link" id="menuLinkSettingsFrontPromos">
                        <i class="fal fa-megaphone fa-fw"></i> Frontpage Promos
                    </router-link>
                </li>
            </ul>
        </li>

        <li v-if="!perms.can_do_everything && perms.can_administer_specialties" class="nav-item nav-dropdown">
            <a class="nav-link nav-dropdown-toggle" href="#" id="menuLinkExpandSettings"><i class="fal fa-cog"></i> Settings</a>
            <ul class="nav-dropdown-items">
                <li class="nav-item">
                    <router-link :to="{ name: 'admin.specialties' }" class="nav-link" id="menuLinkSettingsSpecialties">
                        <i class="fal fa-stethoscope fa-fw"></i> Specialties
                    </router-link>
                </li>
            </ul>
        </li>

        <li v-if="perms.can_do_everything" class="nav-item nav-dropdown">
            <a class="nav-link nav-dropdown-toggle" href="#"><i class="fal fa-trash-alt"></i> Trashed Items</a>
            <ul class="nav-dropdown-items">
                <li class="nav-item">
                    <router-link :to="{ name: 'admin.trashed.campaigns' }" class="nav-link">
                        <i class="fal fa-fire-alt fa-fw"></i> Campaigns
                    </router-link>
                </li>  
                <li class="nav-item">
                    <router-link :to="{ name: 'admin.trashed.checkins' }" class="nav-link">
                        <i class="fal fa-check-circle fa-fw"></i> Check-Ins
                    </router-link>
                </li>  
                <li class="nav-item">
                    <router-link :to="{ name: 'admin.trashed.goals' }" class="nav-link">
                        <i class="fal fa-trophy fa-fw"></i> Goals
                    </router-link>
                </li>  
                <li class="nav-item">
                    <router-link :to="{ name: 'admin.trashed.groups' }" class="nav-link">
                        <i class="fal fa-users-medical fa-fw"></i> Groups
                    </router-link>
                </li>                               
                <li class="nav-item">
                    <router-link :to="{ name: 'admin.trashed.notes' }" class="nav-link">
                        <i class="fal fa-sticky-note fa-fw"></i> Notes
                    </router-link>
                </li>                
                <li class="nav-item">
                    <router-link :to="{ name: 'admin.trashed.physicians' }" class="nav-link">
                        <i class="fal fa-user-md fa-fw"></i> Physicians
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'admin.trashed.routes' }" class="nav-link">
                        <i class="fal fa-route fa-fw"></i> Routes
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'admin.trashed.tasks' }" class="nav-link">
                        <i class="fal fa-tasks fa-fw"></i> Tasks
                    </router-link>
                </li>                                 
            </ul>
        </li>

        <li v-if="homePage" id="install" class="nav-item mt-auto bg-accent text-white text-center font-weight-bold" style="display: none">
            <a class="nav-link" href="#">
                <i class="far fa-mobile-alt fa-fw text-white"></i>
                Add to Home Screen
            </a>
        </li>

    </ul>
  </nav>
</template>

<script>
    import { mapState } from 'vuex';
    export default {
        computed: {
            homePage() {
                return this.$route.name === 'home';
            },

            ...mapState(['perms', 'user'])
        }
    }
</script>